import { generateUtilityClass, generateUtilityClasses } from '@ori-ui/mui-bundle/base';
export function getFeedbackDialogUtilityClass(slot) {
  return generateUtilityClass('MuiOriFeedbackDialog', slot);
}
export const feedbackDialogClasses = generateUtilityClasses('MuiOriFeedbackDialog', ['root', 'banner', 'backdrop', 'closeButton', 'dialogGrid', 'content', 'header', 'text', 'message', 'actions', 'severityError', 'severityInfo', 'severitySuccess', 'severityWarning']);
export default feedbackDialogClasses;
//# sourceMappingURL=feedbackDialogClasses.js.map